// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-dialog__header[data-v-ffe60498]{background:#1a243e;display:flex}.dialog_header[data-v-ffe60498]{display:flex;flex-direction:row;justify-content:space-between;align-items:center;flex:1;color:#fff}.option-buttons[data-v-ffe60498]{display:flex;justify-content:center}[data-v-ffe60498] .el-input-number{width:100%;text-align:left}[data-v-ffe60498] .el-input__inner{text-align:left}[data-v-ffe60498] .el-select{width:177px}", ""]);
// Exports
module.exports = exports;
